module.exports = __webpack_public_path__ + "static/img/category_40.3d953d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/category_40.png
// module id = G7ja
// module chunks = 0